module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery4-983d875407001178509797241316b5f9.jpg";